// src/services/firebaseStorage.js

import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  listAll,
  deleteObject,
} from "firebase/storage";

// Function to delete all previous profile images for the user
const deletePreviousProfileImages = async (userId) => {
  const storage = getStorage();
  const storageRef = ref(storage, `profilePictures/${userId}/`);

  // List all files in the user's profilePictures directory
  const listResult = await listAll(storageRef);

  // Delete all files in the directory
  const deletePromises = listResult.items.map((fileRef) =>
    deleteObject(fileRef)
  );
  await Promise.all(deletePromises);
};

export const uploadProfileImageToFirebase = async (croppedImageUrl, userId) => {
  // Delete previous profile images
  await deletePreviousProfileImages(userId);

  // Upload new profile image
  const response = await fetch(croppedImageUrl);
  const blob = await response.blob();
  const storage = getStorage();
  const storageRef = ref(
    storage,
    `profilePictures/${userId}/${Date.now()}.jpeg`
  );
  await uploadBytes(storageRef, blob);

  // Get the download URL of the uploaded image
  const downloadURL = await getDownloadURL(storageRef);
  return downloadURL;
};

// Delete an image from Firebase Storage
export const deleteChallengeImageFromFirebase = async (imageUrl) => {
  const storage = getStorage();
  const imageRef = ref(storage, imageUrl);

  try {
    await deleteObject(imageRef); // Delete the image
    console.log("Image deleted successfully");
  } catch (error) {
    console.error("Error deleting image:", error);
  }
};

export const uploadChallengeImageToFirebase = async (
  croppedImageUrl,
  userId
) => {
  // Upload challenge hero image
  const response = await fetch(croppedImageUrl);
  const blob = await response.blob();
  const storage = getStorage();
  const storageRef = ref(storage, `challenges/${userId}/${Date.now()}.jpeg`);
  await uploadBytes(storageRef, blob);

  // Get the download URL of the uploaded image
  const downloadURL = await getDownloadURL(storageRef);
  return downloadURL;
};
